(function () {
    "use strict";
    var module = angular.module("app");

    module.factory("authenticationTokenService",
    [
        "keyedStorage", "jwtHelper",
        function (keyedStorage, jwtHelper) {
            var storage = keyedStorage.getOrCreateContainer("authenticationTokenService", {
                authToken: null
            });

            function getAuthToken() {
                return storage.authToken;
            }

            function setAuthToken(token) {
                storage.authToken = token;
            }

            function getDecodedToken() {
                var token = getAuthToken();
                if (!token) return null;
                var decodedToken = jwtHelper.decodeToken(token);
                return decodedToken;
            };

            return {
                getAuthToken: getAuthToken,
                setAuthToken: setAuthToken,
                getDecodedToken: getDecodedToken
            };
        }
    ]);
}());